import React from "react";

const formatDateDMY = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatAmount = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return "-";
  return num.toFixed(2);
};

const getRoomTypeForLog = (log, roomBookings, index) => {
  const roomBookingIdRaw =
    log?.intRoomBookingID ?? log?.RoomBookingID ?? log?.roomBookingId ?? null;
  if (!Array.isArray(roomBookings) || roomBookings.length === 0) {
    return "-";
  }
  let matchedRoom = null;
  if (roomBookingIdRaw) {
    const roomBookingId = String(roomBookingIdRaw);
    matchedRoom = roomBookings.find(
      (room) =>
        String(room?.intRoomBookingID) === roomBookingId ||
        String(room?.RoomBookingID) === roomBookingId ||
        String(room?.roomBookingId) === roomBookingId ||
        String(room?.RoomID) === roomBookingId
    );
  }
  if (!matchedRoom && Number.isInteger(index)) {
    matchedRoom = roomBookings[index] || null;
  }
  const roomTypeName = matchedRoom?.RoomTypeName;
  if (Array.isArray(roomTypeName)) {
    return roomTypeName[0] || "-";
  }
  return roomTypeName || matchedRoom?.RoomType || matchedRoom?.RoomName || "-";
};

const PartialDayCancellationSummary = ({
  modificationLogs,
  modificationError,
  roomBookings,
}) => {
  if (!modificationLogs || modificationLogs.length === 0) {
    return modificationError ? (
      <p className="text-muted mt-2">{modificationError}</p>
    ) : null;
  }

  return (
    <>
      <h5 className="mt-3">Partial Day Cancellation Summary</h5>
      <div className="table-responsive">
        <table
          className="table table-bordered table-hover shadow-sm rounded text-center align-middle"
          style={{ fontSize: "0.85rem" }}
        >
          <thead className="bg-light text-dark fw-semibold">
            <tr>
              <th>Sl#</th>
              <th>Modified On</th>
              <th>Room Type</th>
              <th>Old Check-In</th>
              <th>Old Check-Out</th>
              <th>New Check-In</th>
              <th>New Check-Out</th>
              <th>Deduction (%)</th>
              <th>Deduction (Rs.)</th>
              <th>New Total Amount (Rs.)</th>
              <th>Refund (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            {modificationLogs.map((log, index) => (
              <tr key={log.intBookingModificationLogID || index}>
                <td data-label="Sl#">{index + 1}</td>
                <td data-label="Modified On">
                  {formatDateDMY(log.dtmCreatedOn)}
                </td>
                <td data-label="Room Type">
                  {getRoomTypeForLog(log, roomBookings, index)}
                </td>
                <td data-label="Old Check-In">
                  {formatDateDMY(log.OldCheckIn)}
                </td>
                <td data-label="Old Check-Out">
                  {formatDateDMY(log.OldCheckOut)}
                </td>
                <td data-label="New Check-In">
                  {formatDateDMY(log.NewCheckIn)}
                </td>
                <td data-label="New Check-Out">
                  {formatDateDMY(log.NewCheckOut)}
                </td>
                <td data-label="Deduction (%)">
                  {formatAmount(log.numDeductionPercent)}
                </td>
                <td data-label="Deduction (Rs.)">
                  {formatAmount(log.numDeductionAmount)}
                </td>
                <td data-label="New Total Amount (Rs.)">
                  {formatAmount(log.numRefundBaseAmount)}
                </td>
                <td data-label="Refund (Rs.)">
                  {formatAmount(log.numRefundAmount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PartialDayCancellationSummary;
